import React, { Component } from 'react';
import T from 'prop-types';
// redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import { getProgram } from '../../redux/reducers/program';
// hoc
import withSizes from 'react-sizes';
// components
import DesktopDashboard from './DesktopDashboard';
import MobileDashboard from './MobileDashboard';
import Preloader from '../../components/Preloader/Preloader';
// utils
import get from 'lodash.get';
import getUserRelapseAccess from './utils/getUserRelapseAccess';
import {
  getSkillsAccess,
  getDailyAccess,
  getWeeklyAccess,
  getMonthlyAccess,
} from '../Routes/utils';

class Dashboard extends Component {
  constructor(props) {
    super(props);
    const { user, history } = props;
    const { progress } = user.client_person || user;
    this.currentModule = progress.module;
    this.currentStep = progress.step;
    this.role = user.role;
  }

  componentDidMount() {
    const { modules, getProgram } = this.props;
    const shouldFetchProgram = !modules;
    shouldFetchProgram && getProgram();
  }

  getModuleState = num => {
    const { modules } = this.props;
    if (Number(num) > this.currentModule) return 'incomplete';
    if (Number(num) < this.currentModule) return 'complete';
    if (Number(num) === this.currentModule) {
      const currentModule = modules.find(module => module.weight === +num);
      const stepCount = get(currentModule, 'step_count', null);
      return this.currentStep > stepCount ? 'complete' : 'current';
    }
  };

  render() {
    const { isDesktop, modules, relapseModule, isLoading, user } = this.props;
    // {console.log(modules)}
    const stepCount = get(modules, `${this.currentModule}.step_count`, 0);
    const currentProgress = Math.floor(
      ((this.currentStep - 1) * 100) / stepCount
    );

    const props = {
      getModuleState: this.getModuleState,
      currentModule: this.currentModule,
      role: this.role,
      modules,
      relapseModule,
      currentProgress,
      relapseAccess: getUserRelapseAccess(user),
      dailyAccess: getDailyAccess(user),
      weeklyAccess: getWeeklyAccess(user),
      monthlyAccess: getMonthlyAccess(user),
      skillsAccess: getSkillsAccess(user),
    };

    return (
      <div>
        <Preloader isActive={isLoading} />

        {isDesktop && modules && <DesktopDashboard {...props} />}

        {!isDesktop && modules && <MobileDashboard {...props} />}
      </div>
    );
  }
}

Dashboard.propTypes = {
  modules: T.array,
  isLoading: T.bool.isRequired,
  isDesktop: T.bool.isRequired,
};

export default compose(
  connect(
    state => ({
      user: state.auth.user,
      modules: get(state.program, 'program.programmodules'),
      relapseModule: state.program.relapsemodule,
      isLoading: state.program.isLoading,
    }),
    { getProgram }
  ),
  withSizes(({ width }) => ({
    isDesktop: width >= 768,
  }))
)(Dashboard);



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Dashboard.jsx